/**
 * @file element-actions.ts
 * @description Пункты «⋯» элемента секции — общие для строки сетки и шапки
 * панели элемента (phase19.16 Р2; Р2а — uiux-design-r2a §3, §6):
 * Дублировать · Выше · Ниже · Перенести в другой блок › · Удалить. У
 * обязательного элемента шаблона «Удалить» недоступно с причиной; элемент
 * данных товара не дублируется (в шаблоне он один).
 */

import { isProductElementKind, isProductRequiredKind, type SectionElement } from "@chaiberi/shared";
import { ArrowDown, ArrowUp, Copy, CornerDownRight, Trash2 } from "lucide-react";

import type { RowAction } from "../../../ui/RowActionsMenu";
import { PRODUCT_ELEMENT_DUPLICATE_TEXT, requiredRemoveText } from "../../../../lib/site-builder/product-element-meta";

export interface ElementRowActions {
  duplicate: () => void;
  up: () => void;
  down: () => void;
  remove: () => void;
}

export function elementMenuActions(element: SectionElement, edge: { first: boolean; last: boolean }, actions: ElementRowActions, move: (() => void) | null): RowAction[] {
  const required = isProductRequiredKind(element.kind);
  const single = isProductElementKind(element.kind);
  return [
    { key: "dup", label: "Дублировать", icon: Copy, disabled: single, hint: single ? PRODUCT_ELEMENT_DUPLICATE_TEXT : undefined, run: actions.duplicate },
    { key: "up", label: "Выше", icon: ArrowUp, disabled: edge.first, run: actions.up },
    { key: "down", label: "Ниже", icon: ArrowDown, disabled: edge.last, run: actions.down },
    ...(move ? [{ key: "move", label: "Перенести в другой блок ›", icon: CornerDownRight, run: move }] : []),
    { key: "del", label: "Удалить", icon: Trash2, danger: true, disabled: required, hint: required ? requiredRemoveText(element.kind) : undefined, run: actions.remove },
  ];
}
